import React from "react";

export default function Commiittee() {
  return (
    <div>
      <hr style={{ marginTop: "7rem" }} />
      <div id={"committeeBody"}>
        <div className="about">
          <div className="card border-primary mb-3" style={{ width: "auto" }}>
            <div className="card-body">
              <h5 className="card-title text-primary">ORGANISING COMMITTEE</h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div className="mt-3">
                <div className="text-center">
                  <h4 className="mb-0 mt-3 text-underline">Chief Patron</h4>
                  <br />
                  <strong> Dr. PSK. R. Periaswamy,</strong> <br />
                  Chairman, <br />
                  Kongunadu Institutions.
                  <br />
                  <br />
                  <h4 className="mb-0 mt-3 text-underline">Patrons</h4>
                  <br />
                  <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                      <strong>Er. Kongan. K. Thangavelu</strong> <br />
                      Secretary, <br />
                      Kongunadu Institutions.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Dr. PST. V. S.Thennarasu,</strong> <br />
                      Treasurer, <br />
                      Kongunadu Institutions.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Er. PSK. P. Arunkumar,</strong> <br />
                      Vice-Chairman, <br />
                      Kongunadu Institutions.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Er. PSK. P. Ashok Kumar,</strong> <br />
                      Joint Secretary, <br />
                      Kongunadu Institutions.
                    </div>
                  </div>
                  <h4 className="mb-0 mt-3 text-underline">
                    Conference Coordinator
                  </h4>
                  <br />
                  <strong>Dr. R. Asokan,</strong> <br />
                  Principal, <br />
                  Kongunadu College of Engineering and Technology, <br />
                  Trichy, India.
                  <br />
                  <br />
                  <h4 className="mb-0 mt-3 text-underline">
                    Conference Secretary
                  </h4>
                  <br />
                  <strong>Dr. J. Yogapriya,</strong> <br />
                  Dean (R&amp;D), <br />
                  Kongunadu College of Engineering and Technology, <br />
                  Trichy, India.
                  <br />
                  <br />
                  <h4 className="mb-0 mt-3 text-underline">
                    Conference Co-Coordinator
                  </h4>
                  <br />
                  <strong>Dr.M.Dharmalingam, </strong> <br />
                  HOD/ECE, <br />
                  Kongunadu College of Engineering and Technology, <br />
                  Trichy, India.
                  <br />
                  <br />
                  <h4 className="mb-0 mt-3 text-underline">
                    Conference Co-Secretaries
                  </h4>
                  <br />
                  <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                      <strong>Dr. B. Umarani,</strong> <br />
                      Professor/ECE, <br />
                      KNCET.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Dr. K. Amudha,</strong> <br />
                      Associate Professor/ECE, <br />
                      KNCET.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Dr. P. Elayaraja,</strong> <br />
                      Associate Professor/ECE, <br />
                      KNCET.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Dr. T. Yuvaraja,</strong> <br />
                      Associate Professor/ECE, <br />
                      KNCET.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Mr. V. Bharathi,</strong> <br />
                      Assistant Professor/ECE, <br />
                      KNCET.
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>Mr. D. Karthikeyan,</strong> <br />
                      Assistant Professor/ECE, <br />
                      KNCET.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--  --> */}
        <div className="about">
          <div className="card border-primary mb-3" style={{ width: "auto" }}>
            <div className="card-body">
              <h5 className="card-title text-primary">
                ADVISORY AND TECHNICAL COMMITTEE
              </h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div className="mr-3 ml-3">
                <ul className="card-text" style={{ listStyle: "square" }}>
                  <li>
                    Dr.D.Prakash, Rochester Institute of Technology , USA.
                  </li>
                  <li>
                    Dr. Habil. Henning Muller, University of Applied Sciences,
                    Western Switzerland
                  </li>
                  <li>
                    Dr.Henning Muller, University of Applied Science, Sierre
                  </li>
                  <li>
                    Dr. Rajkumar Buyya, University of Melbourne, Australia
                  </li>
                  <li>
                    Dr. Vassil T. Vassilev, London Metropolitan University, UK
                  </li>
                  <li>
                    Dr.Basim Al-Hadidi, Al-Balqa Applied University, Jordan
                  </li>
                  <li>Dr.Alaa Al-Hamami, Amman Arab University, Jordan</li>
                  <li>
                    Dr. Sattar J Aboud, Iraqi Council of Representatives, Iraq
                  </li>
                  <li>
                    Dr. Omar Alheyasat, Al-Baqla' Applied University, Jordan
                  </li>
                  <li>Dr.R.Rajasekar, NEC Laboratories, Singapore</li>
                  <li>
                    Dr. Ramesh Bansal, University of Pretoria, South Africa
                  </li>
                  <li>
                    Dr. Durgesh Kumar Mishra, Editor-Springer, SAIT, India
                  </li>
                  <li>Dr.K.Krishnakumar, Officer, DRDO, India</li>
                  <li>
                    Dr. SK Hafizul Islam, Indian Institute of Information
                    Technology, India
                  </li>
                  <li>
                    Dr.S.Ashok, National Institute of Technology, Calicut, India
                  </li>
                  <li>
                    Dr.S.Ashok, National Institute of Technolog, Calicut, India
                  </li>
                  <li>
                    Dr.N.P.Gopalan, National Institute of Technology, Trichy,
                    India
                  </li>
                  <li>
                    Dr. P.Palanisamy, National Institute of Technology, Trichy,
                    India
                  </li>
                  <li>
                    Dr.B.V.Manikandan, Senior Professor, Mepco schlenk
                    Engineering College, India
                  </li>
                  <li>Dr.T.Thyagarajan, Anna University, Chennai, India</li>
                  <li>
                    Dr.V.Rhymend Uthariaraj, Anna University, Chennai, India
                  </li>
                  <li>Dr.A.Kannan, Anna University, Chennai, India</li>
                  <li>
                    Dr.K.Vijayakumar, University College of Engineering,
                    Tindivanam, India
                  </li>
                  <li>
                    Dr. B.Balamurugan Balusamy, Galgotia University, India
                  </li>
                  <li>
                    Dr.V.Sivachidambaranathan, Sathyabama University, India
                  </li>
                  <li>Dr. Neeraj Kumar, Thapar University, India</li>
                  <li>Dr.P.Aruna Jeyanthy, Kalasalingam University, India</li>
                  <li>
                    Dr.P.Ajay-D-Vimal Raj, Pondicherry Engineering College,
                    India
                  </li>
                  <li>Dr.Ila Vennila, PSG College of Technology, India</li>
                  <li>Dr. G. Subashini, PSG College of Technology, India</li>
                  <li>
                    Dr. R. Shanmuagalakshmi, Government College of Engineering,
                    India
                  </li>
                  <li>Dr. P.Seethalakshmi, Anna University, Trichy, India</li>
                  <li>
                    Dr. P. Manikandan, Madanapalle Institute of Technology &
                    Science, India
                  </li>
                  <li>Mr. Athif Shah, ABE Semiconductor Design, India</li>
                  <li>
                    Mr. Abhijit Sreenivas, Dell EMC Data Storage Systems, India
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
